import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Fallback redirect callback page для Telegram OAuth.
 * Используется только если embed=1 postMessage не сработал.
 * URL: /tg-auth?id=...&hash=...&auth_date=...
 */

// Запускаем синхронно при загрузке модуля — до React render
// чтобы данные были сохранены как можно раньше
(function saveTelegramDataImmediately() {
  try {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const hash = params.get('hash');
    if (!id || !hash) return;
    const tgData = {};
    params.forEach((v, k) => { tgData[k] = v; });
    localStorage.setItem('tg_auth_pending', JSON.stringify(tgData));
  } catch {}
})();

export default function TelegramCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const hash = params.get('hash');

    if (!id || !hash) {
      navigate('/', { replace: true });
      return;
    }

    const tgData = {};
    params.forEach((value, key) => { tgData[key] = value; });

    // Сохраняем в localStorage (уже сохранено выше, но на случай если не сработало)
    localStorage.setItem('tg_auth_pending', JSON.stringify(tgData));

    // Отправляем postMessage opener-у
    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage({ type: 'TELEGRAM_AUTH', data: tgData }, window.location.origin);
      } catch {}
      setTimeout(() => window.close(), 200);
    } else {
      // Прямой переход (без popup) — идём на главную, localStorage подхватит
      navigate('/', { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#141414',
      color: '#888',
      fontSize: 14,
      fontFamily: 'sans-serif',
    }}>
      Авторизация через Telegram...
    </div>
  );
}

